import { render, staticRenderFns } from "./NpaStagesForm.vue?vue&type=template&id=f8dd57b6"
import script from "./NpaStagesForm.vue?vue&type=script&lang=js"
export * from "./NpaStagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports